import { render, staticRenderFns } from "./BuyerInvoice.vue?vue&type=template&id=112e0ec9&"
import script from "./BuyerInvoice.vue?vue&type=script&lang=js&"
export * from "./BuyerInvoice.vue?vue&type=script&lang=js&"
import style0 from "./BuyerInvoice.vue?vue&type=style&index=0&id=112e0ec9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports